module.exports = __webpack_public_path__ + "static/bsr-logo-with-text-96776e90d3363e13ba820bce59881ada.svg";